import { Validator } from './validator';

export class OfflinePaymentValidator implements Validator {
    validate(validationContext: any): Promise<boolean> {
        return Promise.resolve(true);
    }
}
